export const makeBlankBoard = (board: string[][]): string[][] => {
  return board.map(row => row.map(cell => cell === '.' ? '.' : ''))
}


export type CellToQuestionMapping = {across: number, down: number, first?: number}

export type QuestionMaps = {
  cellToQuestionMap: CellToQuestionMapping[][],
  questionToCellMap: Record<string, {x: number, y: number}>
  acrossQuestionMap: Record<string, string>,
  downQuestionMap: Record<string, string>
  acrossWordMap: Record<string, string>,
  downWordMap: Record<string, string>
}
export const createQuestionMaps = (board: string[][], acrossAnswers: Array<string | null>, downAnswers: Array<string | null>): QuestionMaps  => {
  let questionCount = 0
  let currentDown = 0
  let currentAcross = 0
  const questionMap: CellToQuestionMapping[][]  = []
  const questionToCellMap: Record<string, {x: number, y: number}> = {}
  const acrossQuestionMap: Record<string, string> = {}
  const downQuestionMap: Record<string, string> = {}
  const acrossWordMap: Record<string, string> = {}
  const downWordMap: Record<string, string> = {}
  const downAnswersCopy = [...downAnswers]
  const acrossAnswersCopy = [...acrossAnswers]

  for (let i = 0; i<board.length; i++) {
    const mappedRow: CellToQuestionMapping[] = []
    questionMap.push(mappedRow)
    for (let j = 0; j<board[i].length; j++) {
      if (board[i][j] === '.') {
        mappedRow.push({across: 0, down: 0})
        continue
      }
      let first: number | undefined = undefined
      const isStartOfDown = i-1 < 0 || board[i-1][j] === '.'
      const isStartOfAcross = j-1 < 0 || board[i][j-1] === '.'
      if (isStartOfDown || isStartOfAcross) questionCount++
      if (isStartOfDown) {
        currentDown = questionCount
        first = questionCount
        questionToCellMap[`D${questionCount}`] = {x: j, y: i}
        downQuestionMap[questionCount] = downAnswersCopy.shift() || ''
        let word = ''
        for (let k = i; k < board.length; k++) {
          if (board[k][j] === '.') break
          word += board[k][j]
        }
        downWordMap[questionCount] = word
      }
      else currentDown = questionMap[i-1][j].down
      if (isStartOfAcross) {
        currentAcross = questionCount
        first = questionCount
        questionToCellMap[`A${questionCount}`] = {x: j, y: i}
        acrossQuestionMap[questionCount] = acrossAnswersCopy.shift() || ''
        let word = ''
        for (let k = j; k < board[i].length; k++) {
          if (board[i][k] === '.') break
          word += board[i][k]
        }
        acrossWordMap[questionCount] = word
      }
      else currentAcross = questionMap[i][j-1].across
      mappedRow.push({
        across: currentAcross,
        down: currentDown,
        first,
      })
    }
  }

  return {
    cellToQuestionMap: questionMap,
    questionToCellMap: questionToCellMap,
    acrossQuestionMap,
    downQuestionMap,
    acrossWordMap,
    downWordMap,
  }
}
// If the selected cell is empty we just go to the next cell even if it's not empty
export const findNextOpen = (goingAcross: boolean, currentCell: {x: number, y: number}, board: string[][], isSelectedCellEmpty: boolean): {x: number, y: number} | undefined => {
  if (goingAcross) {
    if (!isSelectedCellEmpty) return {x: currentCell.x+1, y: currentCell.y}
    for (let i = currentCell.x; i < board[0].length; i++) {
      if (board[currentCell.y][i] === '') return {x: i, y: currentCell.y}
      if (board[currentCell.y][i] === '.') break
    }
  }
  else {
    if (!isSelectedCellEmpty) return {x: currentCell.x, y: currentCell.y+1}
    for (let i = currentCell.y; i < board.length; i++) {
      if (board[i][currentCell.x] === '') return {x: currentCell.x, y: i}
      if (board[i][currentCell.x] === '.') break
    }
  }
  return undefined
}


export const crosswordStringToBoard = (grid: string): string[][] => grid.split('\n').map(row => row.split(''))

export const getFirstAvailableCell = (board: string[][]): {x: number, y: number} | undefined => {
  for (let i = 0; i<board.length; i++) {
    for (let j = 0; j<board[i].length; j++) {
      if (board[i][j] === '') return {x: j, y: i}
    }
  }
  return undefined
}

export const isBoardComplete = (board: string[][]): boolean => {
  for (let i = 0; i<board.length; i++) {
    for (let j = 0; j<board[i].length; j++) {
      if (board[i][j] === '') return false
    }
  }
  return true
}